import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AnyObject, FormFieldConfig, FormFieldType, ValueType } from '@mri/types';
import { FormDataSetComponent } from '@mri/app/modules';

@Component({
  selector: 'app-filter-data-set',
  templateUrl: './filter-data-set.component.html',
  styleUrl: './filter-data-set.component.scss'
})
export class FilterDataSetComponent {

  @Input() valueRecord!: Record<string, ValueType | Array<ValueType>>;
  @Input() valueDefaultRecord!: Record<string, ValueType | Array<ValueType>>;
  @Output() valueRecordChange = new EventEmitter<Record<string, ValueType | Array<ValueType>>>();
  @Output() valueRecordSave = new EventEmitter<Record<string, ValueType | Array<ValueType>>>();

  @Input() fields: Array<FormFieldConfig>;
  @Input() mode = 'normal';
  @Input() hideClear = false;
  @Input() buttonPosition: 'top' | 'bottom' = 'top';

  @ViewChild('formComponent') formComponent: FormDataSetComponent;


  onChangeValues(valueRecord: Record<string, ValueType | Array<ValueType>>) {
    this.valueRecord = valueRecord;
    this.valueRecordChange.emit(this.valueRecord);
  }

  clear() {
    const newValue: Record<string, undefined | []> = {};
    this.fields.forEach(field => {
      const keys = field.keys || [field.key];
      keys.forEach(key => {
        newValue[key || ''] = field.type === FormFieldType.OPTIONS_MULTIPLE? []: undefined;
      });

    });
    this.valueRecord = newValue as AnyObject;

    this.valueRecordChange.emit(this.valueRecord);
  }

  submit() {
    this.valueRecordChange.emit(this.formComponent.valueRecord);
  }

  submitAndSave() {
    this.submit();
    this.save();
  }

  save() {
    this.valueRecordSave.emit(this.formComponent.valueRecord);
  }
}
